import { RefObject, useCallback } from 'react';

/** Updates the selection anchor when the caret is moved via arrow keys (without shift). */
const useHandleArrowKeyAnchorSync = ({ selectionAnchorRef }: { selectionAnchorRef: RefObject<number | null> }) => {
  return useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !e.shiftKey) {
        selectionAnchorRef.current = e.currentTarget.selectionStart ?? selectionAnchorRef.current;
      }
    },
    [selectionAnchorRef]
  );
};

export default useHandleArrowKeyAnchorSync;
